import { Reducer } from 'redux';
import { appConfigurationSaga } from './sagas';
import appConfigurationSlice, { APP_CONFIGURATION_KEY_IN_STORE } from './slice';

export class AppConfigurationModule {
	getRootKeyInStore(): string {
		return APP_CONFIGURATION_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return appConfigurationSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return appConfigurationSaga;
	}
}

export const moduleInstance = new AppConfigurationModule();
